import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateVehicleDetails } from '../api/queryKeys';

const useVehicleMutation = (vehicleId, mutationFn) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => invalidateVehicleDetails(queryClient, vehicleId),
  });
};

export default useVehicleMutation;
